(() => {
  const body = document.body;
  if (!body) return;

  const isProduct = () => body.classList.contains('template-product');
  let frame = 0;
  const schedule = (fn) => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      fn();
    });
  };

  const needsScrollLock = () =>
    body.classList.contains('overflow-hidden') ||
    Boolean(document.querySelector(
      'body>.mega-menu-drawer[open],body>.search-popdown[open],body>quick-view.drawer.active,.mini-cart[open],.mini-cart.is-active,.predictive-search[open],.predictive-search.is-open,dialog[open]'
    ));

  function measureCore() {
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    const locked = needsScrollLock();
    const header = document.querySelector('[data-fp-header],#SiteHeader,.site-header,.shopify-section-header');
    const menu = document.querySelector('body>.mega-menu-drawer');
    let menuTop = null;

    if (header && menu) {
      const rect = header.getBoundingClientRect();
      menuTop = body.classList.contains('template-index') && window.scrollY <= 4
        ? Math.max(0, Math.round(rect.top))
        : Math.max(0, Math.round(rect.bottom));
    }

    return { scrollbarWidth, locked, menu, menuTop };
  }

  function applyCore(state) {
    document.documentElement.style.setProperty('--scrollbar-width', `${state.scrollbarWidth}px`);
    document.documentElement.classList.toggle('fp-scroll-locked', state.locked);
    if (state.menu && state.menuTop !== null) {
      state.menu.style.setProperty('top', `${state.menuTop}px`, 'important');
    }
  }

  const core = () => applyCore(measureCore());

  function normalizeProductViewport() {
    if (!isProduct()) return;

    const header = document.querySelector('[data-fp-header-shell],#shopify-section-header [data-fp-header],#shopify-section-header .header');
    const height = Math.max(48, Math.round(header?.getBoundingClientRect().height || 56));

    document.querySelectorAll(
      '.shopify-section-group-announcement-bar-group,[id*="announcement" i],.announcement-bar,.announcement-bar-section,.announcement-bar-wrapper'
    ).forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('hidden', '');
    });

    document.documentElement.style.setProperty('--fp-header-height', `${height}px`);
    body.setAttribute('data-product-header-reclaimed', 'true');
  }

  function transferProductData() {
    if (!isProduct() || body.dataset.fpProductDataReady === '1') return;
    const sources = Array.from(document.querySelectorAll(
      '.product,[data-product-id],[data-product-handle],[data-product-url],[data-product-json],[data-product-container]'
    ));
    if (!sources.length) return;

    const fields = ['productId', 'productHandle', 'productUrl', 'sectionId', 'productJson'];
    document.querySelectorAll(
      '.main-product,.product-section,[data-product-form],[data-product-gallery],product-form,product-gallery,media-gallery'
    ).forEach((target) => {
      if (!(target instanceof HTMLElement)) return;
      for (const source of sources) {
        if (!(source instanceof HTMLElement)) continue;
        for (const field of fields) {
          if (!target.dataset[field] && source.dataset[field]) target.dataset[field] = source.dataset[field];
        }
      }
    });
    body.dataset.fpProductDataReady = '1';
  }

  const productInit = () => {
    normalizeProductViewport();
    transferProductData();
  };

  core();
  productInit();

  window.addEventListener('resize', () => schedule(core), { passive: true });
  window.addEventListener('pageshow', core);
  document.addEventListener('shopify:section:load', () => {
    core();
    if (isProduct()) {
      delete body.dataset.fpProductDataReady;
      productInit();
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('.header,[data-header],.mega-menu-drawer,.search-popdown,.mini-cart,quick-view.drawer,.predictive-search')) {
      schedule(core);
    }
  });

  const isIos =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIos) body.setAttribute('data-ios-device', 'true');
})();